import * as React from 'react';

import { CMHelps } from 'src/containers/CMHelps';
import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
// import Config from '../../site.config.json';
import i18n from '../../resources/i18n';
const title = i18n.t('CMParticipant_0001');

/**
 * ＣＭ受講者ヘルプ画面
 * @param _ propsなし
 */
const CMManual: React.FC<{}> = _ => (
	<React.Fragment>
		<MainMenu />
		<Navbar title={title} />
		<CMHelps />
	</React.Fragment>
);

/**
 * ＣＭ受講者ヘルプ画面
 * @param _ propsなし
 */
export default CMManual;



// WEBPACK FOOTER //
// ./src/pages/help/CMParticipant.tsx